// Web: the Intl polyfills in native.ts are only needed on Hermes; browsers ship Intl.
export {};
